import { LabelAndValue } from '@ktvs8/gocoo-engine-front-end';

/**
 * 発注書フォーマットの定数
 */
export const OrderSheetFormat = {
  Regular: 'レギュラー番組',
  RegularPartial: 'レギュラー番組・部分委託',
  IrregularPartial: '単発番組・部分委託',
  StreamContents: '配信用コンテンツ',
  Illust: 'イラスト',
  Music: '音楽制作',
  Translation: '翻訳',
  CG: 'CG作成',
  Scenario: '脚本',
  RegularDrama: 'レギュラードラマ',
  IrregularDrama: '単発ドラマ',
  PR: 'PRスポット',
};
/**
 * （委託内容）番組の種類の定数
 */
export const Category = {
  Drama: 'ドラマ',
  Variety: 'バラエティ',
  IrregularDrama: '単発ドラマ',
  Information: '情報',
  Music: '音楽',
  Sports: 'スポーツ',
  News: 'ニュース',
  Documentary: 'ドキュメンタリー',
  Other: 'その他',
  PRスポット15秒: 'PRスポット15秒',
  PRスポット30秒: 'PRスポット30秒',
  PRスポット45秒: 'PRスポット45秒',
  PRスポット60秒: 'PRスポット60秒',
};

/**
 * （委託内容）仕様（タイプ）の定数
 */
export const SpecType = {
  VTR: 'VTR収録',
  Live: '生放送',
  Manuscript: '原稿',
  Floppy: 'フロッピー',
  bate: 'βカム',
  CD: 'CD',
  Other: 'その他',
  NONE: '',
};

/**
 * （委託内容）仕様（レギュラータイプ）の定数
 */
export const SpecRegularType = {
  Week: '週',
  Month: '月',
};

/**
 * 委託代金（タイプ）の定数
 */
export const PriceType = {
  Total: '総額',
  Single: '単価',
  OneStory: '1話あたり',
};

/**
 * 受領日タイプの定数
 */
export const ReceiptDateType = {
  Onairdate: '放送当日',
  BeforeOnairdate: '放送日の数日前',
  Direct: '直接指定',
};
/**
 * セレクトボックスの選択肢リストに変換する
 * @param constItem 変換対象の定数
 * @returns
 */
export function ConvertLabelAndValueList(constItem: any): LabelAndValue[] {
  let list: LabelAndValue[] = [];
  for (let key in constItem) {
    list.push({ label: constItem[key], value: key });
  }
  return list;
}

/**
 * keyの値を取得する
 * @param obj
 * @param value
 * @returns
 */
export function getKeyByValue(obj: any, value: any) {
  const key = Object.keys(obj).find((key) => obj[key] === value);
  if (key === undefined) {
    return '';
  }
  return key;
}

/**
 * 発注書を出力際のテンプレートファイル名
 */
export const TemplateFileMap: { [key in string]: OrderSheetTemplateInfo } = {
  Regular: {
    template: 'regular',
    sheetName: 'レギュラー番組発注書（©表示）',
    firstPendingSupplementIndex: 39,
    firstPendingReasonIndex: 30,
  },
  RegularPartial: {
    template: 'regular-partial',
    sheetName: 'レギュラー番組部分委託発注書（©表示）',
    firstPendingSupplementIndex: 40,
    firstPendingReasonIndex: 31,
  },
  IrregularPartial: {
    template: 'irregular-partial',
    sheetName: '単発番組部分委託発注書（©表示）',
    firstPendingSupplementIndex: 39,
    firstPendingReasonIndex: 30,
  },
  StreamContents: {
    template: 'stream-contents',
    sheetName: '配信用コンテンツ発注書（©表示）',
    firstPendingSupplementIndex: 39,
    firstPendingReasonIndex: 30,
  },
  Illust: {
    template: 'illust',
    sheetName: 'イラスト制作委託発注書',
    firstPendingSupplementIndex: 38,
    firstPendingReasonIndex: 29,
  },
  Music: {
    template: 'music',
    sheetName: '音楽作成発注書',
    firstPendingSupplementIndex: 38,
    firstPendingReasonIndex: 29,
  },
  Translation: {
    template: 'translation',
    sheetName: '翻訳委託発注書',
    firstPendingSupplementIndex: 40,
    firstPendingReasonIndex: 31,
  },
  CG: {
    template: 'cg',
    sheetName: 'CG制作委託発注書（©表示）',
    firstPendingSupplementIndex: 38,
    firstPendingReasonIndex: 29,
  },
  Scenario: {
    template: 'scenario',
    sheetName: '脚本執筆依頼発注書（©表示）',
    firstPendingSupplementIndex: 37,
    firstPendingReasonIndex: 28,
  },
  RegularDrama: {
    template: 'regular-drama',
    sheetName: 'レギュラードラマ発注書（©表示）',
    firstPendingSupplementIndex: 39,
    firstPendingReasonIndex: 30,
  },
  IrregularDrama: {
    template: 'irregular-drama',
    sheetName: '単発ドラマ発注書（©表示）',
    firstPendingSupplementIndex: 39,
    firstPendingReasonIndex: 30,
  },
  PR: { template: 'pr', sheetName: 'PRスポット発注書', firstPendingSupplementIndex: 38, firstPendingReasonIndex: 24 },
};

export interface OrderSheetTemplateInfo {
  /**
   * テンプレートのファイル名
   */
  template: string;
  /**
   * シート名
   */
  sheetName: string;
  /**
   * 最初の補足欄のインデックス
   */
  firstPendingSupplementIndex: number;
  /**
   * 最初の未定の理由のインデックス
   */
  firstPendingReasonIndex: number;
}
